import styled from "styled-components";

export const BillingInfo = styled.div`
    margin-top: 10px;
    margin-bottom: 6px;

    font-size: 13px;
    line-height: 1.25;
    color: #4b5563;

    display: flex;
    flex-direction: column;
    gap: 2px;

    @media (max-width: 420px) {
        font-size: 12px;
    }
`;

export const BillingLine = styled.span`
  .strong {
    font-weight: 600;
    color: #111827;
  }
`;
